import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=aa57c488"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"
import style0 from "./verification.vue?vue&type=style&index=0&id=aa57c488&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports